import {actions} from "./Reducer"
/**
 * Actions that fire saga watchers
 */

// Singular
export const createArtisanCategoryAction = (formData) => ({
  type : actions.CREATE_JOB_ARTISAN_CATEGORY,
  payload : formData
})

export const updateArtisanCategoryAction = (id,formData) => ({
  type : actions.UPDATE_JOB_ARTISAN_CATEGORY,
  payload : {
    id,formData
  }
})

// Plural
export const getArtisanCategoriesAction = (body) => ({
  type: actions.GET_JOB_ARTISAN_CATEGORIES,
  payload : body
});

/**
 * Actions that are fired by redux-saga watchers
 */

// Singular
export const createArtisanCategorySuccessAction = category => ({
  type : actions.CREATE_JOB_ARTISAN_CATEGORY_SUCCESS,
  payload : category
})

export const updateArtisanCategorySuccessAction = category => ({
  type : actions.UPDATE_JOB_ARTISAN_CATEGORY_SUCCESS,
  payload : category
})

// Plural
export const getArtisanCategoriesSuccessAction = ArtisanCategories => ({
  type: actions.GET_JOB_ARTISAN_CATEGORIES_SUCCESS,
  payload: ArtisanCategories
});


export const getArtisanParentCategoriesAction = body => ({
  type: actions.GET_JOB_ARTISAN_PARENT_CATEGORIES,
  payload: body
})

export const getArtisanParentCatgoriesSuccesAction = categories => ({
  type: actions.GET_JOB_ARTISAN_PARENT_CATEGORIES_SUCCESS,
  payload: categories
})

/**
 * Misc
*/
export const setArtisanCategoriesIsLoadingAction = isLoading => ({
  type: actions.SET_JOB_ARTISAN_CATEGORIES_IS_LOADING,
  payload: isLoading
});

export const setArtisanCategoriesCountAction = count => ({
  type: actions.SET_JOB_ARTISAN_CATEGORIES_COUNT,
  payload: count
});

export const setSearchValueAction = value => ({
  type : actions.SET_AC_JOB_SEARCH_VALUE,
  payload : value
})